import { ErrorSVG } from 'images/error.svg';
import { NoImageSVG } from 'images/noImage.svg';
import { NoLocationSVG } from 'images/noLocation.svg';
import { UnderStaffedSVG } from 'images/understaffed.svg';
import { UserMissing } from 'images/user_missing';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

export type ErrorCode = ( 'understaffed' | 'no_location' | 'stacked' | 'error' | 'ignore' | 'no_image' | 'expiration_date' | 'equipment_stack' | 'user_missing' )

export class ErrorIconsProps {
  error: ErrorCode | undefined;
  defaultString?: string | React.ReactElement | boolean;
  component?: React.ReactElement;
  size?: number | undefined;
  className?: string;
  tooltip?: string;

  static icons = {
    'understaffed': <UnderStaffedSVG fill="#ff6c00"/>,
    'user_missing': <UserMissing fill="#ff6c00"/>,
    'no_location': <NoLocationSVG fill="#ff6c00" stroke="#404040"/>,
    'error': <ErrorSVG fill="#ff6c00" stroke="#202020" strokeWidth={0.75}/>,
    'no_image': <NoImageSVG stroke="#ff5533"/>,
    'stacked': null,
    'expiration_date': <ErrorSVG stroke="#ff6c00"/>,
    'equipment_stack': <ErrorSVG stroke="#ff6c00"/>,
    'ignore': null
  };

  static getComponent( size: number | undefined, error: ErrorCode | undefined = 'error', className = 'mx-0.5', tooltip?: string ) {
    const [ icon, setIcon ] = useState( ErrorIconsProps.icons[ error ] );
    const { t } = useTranslation();

    useEffect( () => {
      if ( icon == null ) {
        setIcon( ErrorIconsProps.icons[ 'error' ] );
      }
    }, [] );

    const tooltipId = `error-tooltip-${error}-${Math.random().toString( 36 ).substr( 2, 9 )}`;


    return (
      <div>
        <div
          className={className}
          style={ size ? { width: ( size / 4 ) + 'rem', height: ( size / 4 ) + 'rem' } : {} }
          data-tooltip-id={tooltipId}
          data-tooltip-content={ tooltip ? tooltip : icon ? t( `translation:image_errors.${error}` ) : undefined}
        >
          {icon}
        </div>
        <Tooltip
          id={tooltipId}
          place="top"
          delayShow={100}
          positionStrategy="fixed"
          style={{
            backgroundColor: '#333',
            color: 'white',
            fontSize: '12px',
            borderRadius: '4px',
            padding: '4px 8px',
            zIndex: '100'
          }}
        />
      </div>
    );
  }
}

export const ErrorIcons = ( props: ErrorIconsProps ) => {
  if ( props.defaultString == null || props.defaultString === '' || props.defaultString === true ) {
    return ErrorIconsProps.getComponent( props.size, props.error, props.className, props.tooltip );
  }
  if ( props.component != null ) {return props.component;}
  return props.defaultString;
};